/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-09-10 22:07:56
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-19 18:17:02
 */
import { format } from 'date-fns';
import { PLATFORM_ID_LIST, PLATFORM_OBJ, PLATFORM_DY, PLATFORM_KS, PLATFORM_SP } from '@/utils/dataMap';
//时间
export function formatTime(val, formatStr) {
	if (!val || val == 0) {
		return '-';
	}
	if (formatStr) {
		return format(Number(val) * 1000, formatStr);
	} else {
		return val;
	}
}

//时间 年月日
export function formatDate(val) {
	if (!val || val == 0) {
		return '-';
	}
	if ((val + '').length == 10) {
		return format(Number(val) * 1000, 'yyyy-MM-dd');
	} else {
		return format(Number(val), 'yyyy-MM-dd');
	}
}

//时间 年月日时分秒
export function formatDateTime(val) {
	if (!val || val == 0) {
		return '-';
	}
	if ((val + '').length == 10) {
		return format(Number(val) * 1000, 'yyyy-MM-dd HH:mm:ss');
	} else {
		return format(Number(val), 'yyyy-MM-dd HH:mm:ss');
	}
}

//倒计时 计算倒计时还剩天小时分钟秒
export function formatCountDownDate(val) {
	if (!val && val != 0) {
		return '-';
	}
	const _f = time => {
		return time < 10 ? `0${time}` : time;
	};
	const days = parseInt(val / (60 * 60 * 24));
	const hours = parseInt((val % (60 * 60 * 24)) / (60 * 60));
	const minutes = parseInt((val % (60 * 60)) / 60);
	const seconds = parseInt(val % 60);
	return `${days}天${_f(hours)}小时${_f(minutes)}分钟${_f(seconds)}秒`;
}
// 格式化文本，超出省略号
export const textFormat = function (str, numb) {
	if (!str) return;
	return str.length > numb ? `${str.substr(0, numb)}...` : str;
};

//根据平台ID获取平台名称
export function formatPlatformName(val, type = 'name') {
	if (!PLATFORM_ID_LIST.includes(+val)) return '-';
	const name = PLATFORM_OBJ[+val].label;
	const fulObj = {
		suf: {
			[PLATFORM_DY.value]: '号',
			[PLATFORM_KS.value]: 'ID',
			[PLATFORM_SP.value]: 'ID',
		},
		unify: {
			[PLATFORM_DY.value]: '号',
			[PLATFORM_KS.value]: '号',
			[PLATFORM_SP.value]: 'ID',
		},
	};
	return name + (fulObj[type]?.[val] || '');
}

// 空数据格式化为‘-’
export function formatEmpty(val) {
	return ['', void 0, null, 'null'].includes(val) ? '-' : val;
}

// 格式化价格
export function formatPrice(val) {
	return ['', '-'].includes(val) ? val : `¥${val}`;
}

// 格式化价格，千分位展示
export function formatPrice2(val) {
	return val === '-' ? val : String(val).replace(String(val).indexOf('.') > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(\d{3})+$)/g, '$1,');
}

// 格式化价格，转化为元，并加上人民币前缀
export function formatPrice3(val) {
	return val === '-' ? val : (val / 100).toFixed(2);
}

// 格式化元，保留两位小数点
export function formatPrice4(val) {
	return val === '-' ? val : val.toFixed(2);
}
// 格式化百分比
export function formatPercent(val) {
	return `${Math.round(val * 10000) / 100}%`;
}

// 格式化百分比(不需要乘以100)
export function formatPercent2(val) {
	// 防止val返回null值
	return ['', void 0, null, 'null', '-', '--'].includes(val) ? '-' : `${val}%`;
}
// 获取单位
export function unitFormat(value) {
	let val = Number(value);
	if (val >= 10 ** 4 && val < 10 ** 8) return '万';
	else if (val >= 10 ** 8) return '亿';
	else return '';
}
export function unit1Format(value) {
	let val = Number(value);
	if (val >= 10 ** 3 && val < 10 ** 4) return `${Math.round((val / 10 ** 3) * 100) / 100}k`;
	else if (val >= 10 ** 4) return `${Math.round((val / 10 ** 4) * 100) / 100}w`;
	else return val;
}
